import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getSortOptions = (state: ContentPluginRootState) => state.data.results?.sort;

export default getSortOptions;
